import { c as _c } from "react/compiler-runtime";
import { CommandItem } from '@repo/ui/components';
export const CmdkSearchHost = t0 => {
  const $ = _c(5);
  const {
    search
  } = t0;
  let t1;
  if ($[0] !== search) {
    t1 = [search];
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `__cmdk-search-host__-${search}`;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <CommandItem aria-hidden={true} className="hidden" disabled={true} keywords={t1} value={t2} data-sentry-element="CommandItem" data-sentry-component="CmdkSearchHost" data-sentry-source-file="cmdk-search-host.tsx" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};